import React from 'react'
import styled from 'styled-components'
import { PlusIcon } from '@components/Icons'
import tw from 'twin.macro'

const PlusIconContainer = styled(PlusIcon)`
  margin-right: 4px;
  display: block;
  width: 16px;
  height: 16px;
`

const FollowButtonContainer = styled.div`
  ${tw`text-h6 font-medium`}
  width: 75px;
  background-color: #2c2593;
  padding: 0 12px;
  height: 32px;
  color: white;
  border-radius: 24px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`

const FollowButton = ({ onClick }) => {
  return (
    <FollowButtonContainer onClick={onClick}>
      <PlusIconContainer />
      <span>追蹤</span>
    </FollowButtonContainer>
  )
}

export default FollowButton
